export default {
  name: "Nature of H-2A Application",
  prefix: "A",
  pageInfo: {
    text: "<b><em>IMPORTANT: </em></b> : Employers and authorized preparers must read these instructions carefully before completing the Form ETA9142A – H-2A <i>Application for Temporary Employment Certification</i>, and all required appendices. These instructions contain full explanations of the questions and attestations that make up the Form ETA-9142A. If you are not submitting these forms electronically, please complete <u>ALL</u> required items containing an asterisk ( * ) and any applicable fields/items where a response is conditionally required, as indicated by the section ( § ) symbol. <br /><br />Anyone who knowingly and/or willingly furnishes any false information in the preparation of Form ETA-9142A and/or any supplement thereto, or aids, abets, or counsels another to do so, is committing a federal offense, punishable by fines, imprisonment, or both (18 U.S.C. §§ 2, 1001). Other penalties apply as well to fraud or misuse of this immigration document and to perjury with respect to this form (18 U.S.C. §§ 1546, 1621).",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          isGroup: {
            machine_name: "a1_employer_type",
            code: "A.1",
            label: "Type of Employer Application?",
            tooltip:
              "Select one of the following options to indicate the type of application being filed for temporary employment certification.",
            coloring: "none",
            required: true,
            isVisible: {
              when: "formVersionId",
              is: 1,
            },
            fields: [
              {
                widget: "radio",
                choice: "Individual Employer",
                value: "individual",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice:
                  "Joint Employer <i>(2 or more individual employers)</i>",
                value: "joint",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice: "Association - Sole Employer",
                value: "association-sole",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice: "Association - Joint Employer",
                value: "association-joint",
                validate: [
                  "required",
                  {
                    fieldCompletedWhenOtherFieldIsUntouched: "a1_employer_type",
                    needsFieldValues: true,
                    message:
                      "You indicated this application will be filed by or on behalf of an agricultural association acting as a joint employer with its members (i.e., a “master” application). Please remember that each employer-member seeking to jointly employ H-2A workers with the agricultural association under this application must be identified on the Form ETA-790A, Addendum B.",
                    extraData: {
                      when: "e3_is_job_order_complete",
                      is: "association-joint",
                    },
                  },
                ],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice: "Association - Agent",
                value: "association-agent",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
            ],
          },
        },
        //V2
        {
          isGroup: {
            machine_name: "a1_employer_type",
            code: "A.1",
            label: "Type of Employer Application?",
            tooltip:
              "Select one of the following options to indicate the type of application being filed for temporary employment certification.",
            coloring: "none",
            required: true,
            isVisible: {
              when: "formVersionId",
              is: 2,
            },
            fields: [
              {
                widget: "radio",
                choice: "Individual Employer",
                value: "individual",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice:
                  "Joint Employer <i>(2 or more individual employers)</i>",
                value: "joint",
                validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
            ],
          },
        },
        // V2
        {
          isGroup: {
            machine_name: "a1_employer_type_a",
            code: "A.1a",
            label:
              "Agricultural Association Employer or Agency Status, if applicable.",
            tooltip:
              "If an agricultural association is filing the application, select one of the following options to indicate the agricultural association’s employer or agency status. 20 CFR 655.131(a)(1).",
            coloring: "none",
            // required: true,
            isVisible: {
              when: "formVersionId",
              is: 2,
            },
            clearBtn: {
              clearSchema: [
                "a1_employer_type_a",
                "e4_is_joint_employer_complete",
              ],
              clearFiles: [],
            },
            fields: [
              {
                widget: "radio",
                choice: "Association - Sole Employer",
                value: "association-sole",
                // validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice: "Association - Joint Employer",
                value: "association-joint",
                validate: [
                  // "required",
                  {
                    fieldCompletedWhenOtherFieldIsUntouched:
                      "a1_employer_type_a",
                    needsFieldValues: true,
                    message:
                      "You indicated this application will be filed by or on behalf of an agricultural association acting as a joint employer with its members (i.e., a “master” application). Please remember that each employer-member seeking to jointly employ H-2A workers with the agricultural association under this application must be identified on the Form ETA-790A, Addendum B.",
                    extraData: {
                      when: "e3_is_job_order_complete",
                      is: "association-joint",
                    },
                  },
                ],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
              {
                widget: "radio",
                choice: "Association - Agent",
                value: "association-agent",
                // validate: ["required"],
                clearSchema: ["e4_is_joint_employer_complete"],
              },
            ],
          },
        },
        {
          isGroup: {
            machine_name: "a2_is_contractor",
            code: "A.2",
            label:
              "Is the employer operating as an H-2A Labor Contractor (H-2ALC), as defined by 20 CFR 655.103(b)?",
            tooltip:
              "Select “Yes” or “No” to indicate if the employer requesting certification is operating as an H-2A Labor Contractor (H-2ALC). Pursuant to 20 CFR 655.103(b), an H-2ALC is defined as any person who meets the definition of employer and is not a fixed-site employer, an agricultural association, or an employee of a fixed-site employer or agricultural association, as those terms are defined in 20 CFR 655.103(b), who recruits, solicits, hires, employs, furnishes, houses, or transports any worker subject to 8 U.S.C. 1188, 29 CFR part 501, or 20 CFR part 655, subpart B.",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: [
                  "required",
                  {
                    fieldCompletedWhenOtherFieldIsUntouched: "a2_is_contractor",
                    needsFieldValues: true,
                    message:
                      "You indicated that the employer requesting temporary labor certification is operating as an H-2A Labor Contractor. Please remember that the name(s) and location(s) of each fixed-site agricultural business, the expected beginning and ending dates regarding when the workers will be provided to each fixed-site, and a description of the crops and activities the workers are expected to perform at each fixed-site must be identified on the Form ETA-790A, Addendum B.",
                    extraData: {
                      when: "e3_is_job_order_complete",
                      is: "YES",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
        {
          isGroup: {
            machine_name: "a3_nature_of_need",
            code: "A.3",
            label: "Nature of Temporary Need",
            tooltip:
              "Select one of the following options to indicate the nature of the employer’s temporary need for the services or labor to be performed. Only one standard of temporary need may be selected.",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Seasonal",
                value: "seasonal",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Other Temporary Need",
                value: "other_temporary_need",
                validate: ["required"],
              },
            ],
          },
        },
        {
          isGroup: {
            machine_name: "a4_is_temp_need_complete",
            code: "A.4",
            label: "Are you attaching a statement of temporary need?",
            tooltip:
              "Select “Yes” or “No” to indicate whether a statement explaining how the employer’s need for the agricultural services or labor to be performed is seasonal or temporary in nature is attached to the application. If submitted, the employer’s statement must explain (a) the nature of the employer’s business or operations, (b) why the job opportunity and number of workers being requested for certification reflect a temporary need, and (c) how the employer’s request for the services or labor to be performed meets the seasonal need standard or otherwise qualifies as temporary. If the nature of the employer’s need changes, is unclear, and/or requires further explanation beyond the information on the forms and statement, if submitted, the CO will issue a NOD requesting additional explanation or supporting documentation.",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                warning: {
                  text: "You indicated that the nature of the employer's need for H-2A workers is not seasonal and a statement explaining how the employer’s need is temporary in nature will NOT be attached to the application. Please remember that in circumstances where the nature of the employer’s need changes, is unclear, and/or requires further explanation beyond the information provided with your application, the Certifying Officer will issue a NOD requesting additional explanation or supporting documentation.",
                  isVisible: {
                    when: "a3_nature_of_need a4_is_temp_need_complete",
                    is: ["other_temporary_need", "NO"],
                    operator: "compareMultiFieldValues",
                  },
                },
              },
            ],
          },
        },
        {
          machine_name: "a4_is_temp_need_complete_file",
          code: "A.4.A",
          isVisible: {
            when: "a4_is_temp_need_complete",
            is: "YES",
          },
          widget: "file_upload",
          label: "Upload a statement of temporary need.",
          name: "Temporary Need Statement",
          fileTypes: [".pdf", ".png", ".jpg"],
          validate: ["required", "checkValue"],
          tooltip:
            "<strong><i>Important Note:</i></strong> If the employer is filing the application electronically and marks “YES”, the electronic filing system will require the employer to upload an electronic document or statement demonstrating temporary need in order for the application to be submitted for processing.",
        },
        {
          code: "I5",
          machine_name: "files",
          widget: "text",
          hidden: true,
        },
      ],
    },
  ],
};
